'use client';

import { defineMessages, useIntl } from 'react-intl';

import type { ResponsiveNavigationLayoutProps } from './ResponsiveNavigationLayout';
import { ResponsiveFullBleedBackground } from './ResponsiveFullBleedBackground';

export type ResponsiveNavigationLayoutWrapperProps = Omit<
  ResponsiveNavigationLayoutProps,
  'hamburgerClassNames'
>;

const messages = defineMessages({
  primaryNavigationCategoriesContainer: {
    id: 'primary.navigation.categories.container.label',
    defaultMessage: 'Hauptnavigationskategorien',
  },
});

export const ResponsiveNavigationLayoutWrapper = ({
  children,
  isLevel2Visible,
  hamburgerShouldBeMounted,
  button,
}: ResponsiveNavigationLayoutWrapperProps) => {
  const { formatMessage } = useIntl();
  return (
    // eslint-disable-next-line jsx-a11y/role-supports-aria-props
    <nav
      aria-label={formatMessage(messages.primaryNavigationCategoriesContainer)}
      className="relative [grid-area:nav]"
      aria-expanded={isLevel2Visible || hamburgerShouldBeMounted}
      // no need to have grid-area:nav here, its already being used on parent div, its not a direct child to the grid container.
    >
      <ResponsiveFullBleedBackground className="border-color-grey border-y" />
      {button}
      {children}
    </nav>
  );
};
